<template>
  <div class="filelist-modal">
    <div class="dialog-header" v-if="title">
      <h1>{{ title }}</h1>
    </div>
    <div class="dialog-content">
      <div v-html="text"></div>
      <div class="footer-menu">
        <button
          class="pill-button"
          :style="buttons.pillDefault"
          @click="$emit('close')"
        >
          Sluiten
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'text'],
  methods: {},
  computed: {
    buttons() {
      return this.rootStore.buttons
    }
  }
}
</script>

<style lang="scss" scoped>
.vm--modal .dialog-content {
  padding-bottom: 78px;
}
</style>
